"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssClass = exports.keyframes = exports.classes = void 0;
var typestyle_1 = require("typestyle");
var typestyle_2 = require("typestyle");
Object.defineProperty(exports, "classes", { enumerable: true, get: function () { return typestyle_2.classes; } });
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return typestyle_2.keyframes; } });
var cssPrefix = 'PredictiveModelUI';
function cssClass(name) {
    var styles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        styles[_i - 1] = arguments[_i];
    }
    return typestyle_1.style.apply(void 0, __spreadArray(__spreadArray([], styles, false), [{
            $debugName: "".concat(cssPrefix, "_").concat(name),
            $unique: true,
        }], false));
}
exports.cssClass = cssClass;
//# sourceMappingURL=StyleHelper.js.map